import { NeighborhoodJob } from 'rwl-shared/dist/models';
import { IconOption } from 'rwl-shared/dist/models/widget';
import JobMarkerContent from './Content/JobMarkerContent';
import JobPopover from '../Popovers/JobPopover';
import { UnpublishedMarker } from './UnpublishedMarker';
import { UnpublishedPopover } from '../Popovers/UnpublishedPopover';
import { BaseMarker, HoverState } from './BaseMarker';
import { useJob } from '../../../fetchers';

type JobMarkerProps = {
    position: google.maps.LatLngLiteral;
    iconTint: string;
    job: NeighborhoodJob;
    icon: IconOption;
    onClick?: () => void;
    onHover?: (state: HoverState) => void;
};

export const JobMarker = ({
    position,
    iconTint,
    icon,
    job,
    onClick,
    onHover,
}: JobMarkerProps) => {
    const { job: selectedJob } = useJob();

    const markerContent = job.published ? (
        <JobMarkerContent
            icon={icon}
            iconTint={iconTint}
            onClick={onClick}
            isSelected={selectedJob?.id === job.id}
            hasReview={!!job.reviewId}
        />
    ) : (
        <UnpublishedMarker iconTint={iconTint} />
    );

    const popoverContent = job.published ? (
        <JobPopover
            job={job}
            onClick={() => {
                onClick?.();
            }}
        />
    ) : (
        <UnpublishedPopover />
    );

    return (
        <BaseMarker
            position={position}
            markerContent={markerContent}
            popoverContent={popoverContent}
            popoverAnchor="bestCenter"
            onMarkerClick={() => {
                if (job.published) {
                    onClick?.();
                }
            }}
            onMarkerHover={(state) => onHover?.(state)}
        />
    );
};
